import React from "react";
import { Container, Row, Col, Placeholder, Card } from "react-bootstrap";
import styles from "./states.module.css";
import Avatar from "@/assets/img/user_pic.svg";

const ProfileLoading = () => {
  return (
    <div className={styles.profilePage}>
      <div className={styles.header}>
        <div>
          {" "}
          <img
            src={Avatar}
            alt="Avatar"
            className="rounded-circle hover"
            width="82px"
            height="82px"
          />
        </div>
        <div className={styles.info}>
          <Placeholder
            as="p"
            animation="glow"
            className={styles.placeholder_profile}
            style={{ height: "20px", width: "128px" }}
          />
          <Placeholder
            as="p"
            animation="glow"
            className={styles.placeholder_profile}
            style={{ height: "27px", width: "619px" }}
          />
          <Placeholder
            as="p"
            animation="glow"
            className={styles.placeholder_profile}
            style={{ height: "16px", width: "218px", marginTop: "16px" }}
          />
          <Placeholder
            as="p"
            animation="glow"
            className={styles.placeholder_profile}
            style={{ height: "24px", width: "270px" }}
          />
        </div>
      </div>

      <Container>
        <Row className={styles.profile_body}>
          <Col>
            <Placeholder
              as="p"
              animation="glow"
              className={styles.grey_placeholder}
              style={{
                height: "24px",
                width: "370px",
                marginBottom: "12px",
              }}
            />
            <div className={styles.hr_border}></div>
            <Card className={styles.section_1}>
              <Card.Body>
                <Row>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.placeholder_body}
                      style={{ height: "16px", width: "218px" }}
                    />
                  </Col>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.placeholder_body}
                      style={{ height: "16px", width: "218px" }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "8px" }}>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.placeholder_body}
                      style={{ height: "18px", width: "270px" }}
                    />
                  </Col>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.placeholder_body}
                      style={{ height: "18px", width: "270px" }}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Card className={styles.section_2}>
              <Card.Body>
                <Placeholder
                  as="p"
                  animation="glow"
                  className={styles.prfile_new_color}
                  style={{
                    height: "24px",
                    width: "370px",
                    marginBottom: "12px",
                  }}
                />
                <Row>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.prfile_new_color}
                      style={{
                        height: "18px",
                        width: "175px",
                      }}
                    />
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.prfile_new_color}
                      style={{
                        height: "18px",
                        width: "120px",
                        marginTop: "4px",
                      }}
                    />
                  </Col>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.prfile_new_color}
                      style={{
                        height: "18px",
                        width: "175px",
                      }}
                    />
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.prfile_new_color}
                      style={{
                        height: "18px",
                        width: "120px",
                        marginTop: "4px",
                      }}
                    />
                  </Col>
                  <Col>
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.prfile_new_color}
                      style={{
                        height: "18px",
                        width: "175px",
                      }}
                    />{" "}
                    <Placeholder
                      as="p"
                      animation="glow"
                      className={styles.prfile_new_color}
                      style={{
                        height: "18px",
                        width: "120px",
                        marginTop: "4px",
                      }}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfileLoading;
